import AppLayoutGuest from "@/layouts/AppLayoutGuest.vue";
import Login from "@/pages/auth/Login.vue";
import Otp from "@/pages/auth/Otp.vue";


const authRoutes =  {
    path: "/login",
    component: AppLayoutGuest,

    children: [

        {
            path: "",
            name: "AuthLogin",

            component: Login
        },
        {
            path: "otp",
            name: "Otp",
            meta:{requiredAuth:false},
            component: Otp
        },
    ]
}

export default authRoutes